import React, { useState, useEffect, useMemo } from 'react'
import {CardActions, TextField, useMediaQuery} from "@mui/material";
import MaterialReactTable from 'material-react-table';
import {  useDispatch } from 'react-redux';
import {Grid, Card,CardContent, Dialog, DialogContent,DialogActions,DialogTitle,Button,Typography,Box,Stepper,FormControl,TextareaAutosize,InputAdornment,OutlinedInput,Tooltip,IconButton,
  Step, StepLabel,StepConnector,styled,InputLabel} from "@mui/material";
import Moment from 'moment';
import AuthUser from '../../../../Components/Auth/AuthUser';
import swal from "sweetalert";
import { fetchData,postFormData } from '../../../../redux/apiSlice';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../../Components/Loader/Loader';
import ActivityLog from '../Components/ActivityLog';
import { useNavigate } from 'react-router-dom';
import { CardOverflow } from '@mui/joy';
import * as Yup from 'yup';
import { Formik } from 'formik';
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Girl } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import WatermarkedImage from './WaterMarkImage';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const allSteps = [
    "Service Request Accepted",
    "Expert Assigned",
    "Pending For Review",
    "Approved",
    "Completed"
  ];
// Custom Connector
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    minHeight: 17,
    borderLeftWidth: 2,
    borderColor: '#6C6F6C',
    marginLeft: -8,
  },
}));

// Custom Icon
const CustomStepIcon = ({ active }) => (
  <Box
    sx={{
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: active ? '#1ECF56' : '#6C6F6C',
    }}
  />
);






function AvailedServicesIndex() {
    const dispatch = useDispatch();
    const {http,user} = AuthUser();
     const fileInputRef = React.useRef(null);
    const [companyId, setCompanyId] = React.useState(user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5 ? user.company_master_id : '');
    const [data, setData] = useState([]);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [freez, setFreez] = React.useState(false);
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState('services');
    const [maxWidth, setMaxWidth] = React.useState('sm');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [openApprove, setOpenApprove] = React.useState(false);
    const [mediaConfigId,setMediaConfigId]=useState("");
    const [mediaServiceId,setMediaServiceId]=useState("");
    const [files, setFiles] = useState([]);
    const [activityType, setActivityType] = useState('');
    const [activityLog, setActivityLog] = useState([]);
    const [requestId,setRequestId]=useState("");
    const [mediatype,setMediaType]=useState("");
    const [assetLink, setAssetLink] = useState('');
   const [approveMediaType, setApproveMediaType] = useState("");
   const [approveMediaStatus, setApproveMediaStatus] = useState("");
   const [folderName, setFolderName] = useState("");
    const [expandedIndexes, setExpandedIndexes] = useState([]);
    const handleClickOpen = (id,media_service_id,type) => {
        setMediaConfigId(id);
        setMediaServiceId(media_service_id);
        setMediaType(type)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenAssets = async(id,media_service_id,type) => {
            handleFreezStart();
            setRequestId(id);
            setMediaServiceId(media_service_id);
            setApproveMediaType(type)
            const folderName="assets"
            const apiUrl = `/viewFile/${companyId}/${media_service_id}/${folderName}`;
            const res = await dispatch(fetchData(apiUrl )).unwrap();
            if (res) {
                if (res.success == true) {
                    setFiles(res.data);
                    handleFreezStop();
                } else {
                    handleFreezStop();
                }
            } else {
                swal({
                    title: "Failed",
                    text: "Network Error",
                    icon: "error",
                    button: "Ok",
                });
            }
            setOpen1(true);
        };
    

    const handleOpenViewFile = async(media_service_id,folderName,id,type,status) => {
        setFolderName(folderName);
        setMediaServiceId(media_service_id);
        setApproveMediaType(type);
        setRequestId(id);
        setApproveMediaStatus(status);
        handleFreezStart();
        const apiUrl = `/viewFile/${companyId}/${media_service_id}/${folderName}`;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            if (res.success == true) {
                setFiles(res.data);
                handleFreezStop();
            } else {
                handleFreezStop();
            }
        } else {
            swal({
                title: "Failed",
                text: "Network Error",
                icon: "error",
                button: "Ok",
            });
        }
        setOpen1(true);
    };

    const handleCloseViewFile = () => {
        setOpen1(false);
    };

    const viewActivity = async(id,type) => {
        const apiUrl = '/getMediaServiceActivityLog/'+ id + '/' + type;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            console.log("ds",res.data);
            setActivityLog(res.data);
            setActivityType(type == "video" ? (res.data.media_service.service_name + " Video") : "Logo Design");
            setActiveSection('activityLog')
        }
    }

    const setOpenApprovePopup= async(id,type) => {
        setRequestId(id);
        setMediaType(type);
        setOpenApprove(true);
       

    }
    const setApprove = async(id,type) => {
        handleFreezStart();
        const apiUrl = '/updateMediaService/'+ id + '/' + type;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            swal({
                title: "Success",
                text: res.message,
                icon: "success",
                button: "Ok",
            });
            handleFreezStop();
            setOpenApprove(false);
            setOpen1(false);
            getActivityLog();
        } else {
            swal({
                title: "Failure",
                text: res.message || "Something went wrong",
                icon: "error",
                button: "Ok",
            });
            handleFreezStop();
            setOpenApprove(false);
        }
    }
    
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    useEffect(() => {
        getActivityLog();
    }, []);

    const getActivityLog = async() => {
        handleFreezStart();
        const apiUrl = '/getMediaServiceDetails/'+companyId;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            if (res.success == true) {
                handleFreezStop();
                // setData(res.data);
                const apiData = res.data;
                setAssetLink(res.data.assets_link);
                const videos = apiData.video_config.map(item => ({
                    requestId:item.id,
                    id: item.id,
                    media_service_id: item.media_service_id,
                    media_type: item.media_service.service_type,
                    status: item.status,
                    completed_on: item.completed_on,
                    title: item.media_service.service_name,
                    // note: item.note,
                    // description: item.video_details.description,
                    created_at: item.created_at,
                    updated_at: item.updated_at
                    }));

                    const logo = apiData?.logo_config
                    ? [{
                        requestId:apiData.logo_config.id,
                        id: apiData.logo_config.id,
                        media_service_id: apiData.logo_config.media_service_id,
                        media_type: apiData.logo_config.media_service?.service_type ?? '',
                        title: apiData.logo_config.media_service?.service_name ?? '',
                        status: apiData.logo_config.status,
                        completed_on: apiData.logo_config.completed_on,
                        created_at: apiData.logo_config.created_at,
                        updated_at: apiData.logo_config.updated_at
                      }]
                    : [];

                const combinedMedia = [...videos, ...logo];
                setData(combinedMedia);
            } else {
                handleFreezStop();
            }
        } else {
            swal({
                title: "Failed",
                text: "Network Error",
                icon: "error",
                button: "Ok",
            });
        }
    }
    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        description: Yup.string().required('Description is required')
             .max(200, 'Description cannot be more than 200 characters'),
    });
   
    return (
        <>
        {activeSection === 'services' ?
        <Grid container item lg={12} md={12} sm={12} xs={12}>
        {data.map((item, idx) => {
             const uniqueKey = `${item.id}-${idx}`;
            const isExpanded = expandedIndexes.includes(uniqueKey);
            const normalizedStatus = item.status === "In Process"
            ? "Expert Assigned"
            : item.status;
           const statusIndex = allSteps.indexOf(normalizedStatus);
            const steps = allSteps.map((label, i) => ({
                label,
                active: i <= statusIndex
            }));
            
            return (
                <Card key={`card-${idx}`} variant="outlined" sx={{ borderRadius: '10px', border: '1px solid #2E67BC', boxShadow: 'none', width: '100%', mb: 3 }}>
                    <CardContent>
                        <Grid container spacing={1}>
                            {/* Column 1: Service Name */}
                            <Grid item lg={3} md={3} sm={6} xs={12}>
                                <Typography>Service Name:</Typography>
                                <Typography fontWeight="bold">{item.title || 'N/A'}</Typography>
                                {!isExpanded && (
                                    <>
                                        <Typography mt={2}>Delivery Date:</Typography>
                                        <Typography fontWeight="bold">{item.completed_on ? Moment(item.completed_on).format('MM-DD-YYYY') : 'N/A'}</Typography>
                                    </>
                                )}
                            </Grid>

                            {/* Column 2: Service Requested */}
                            <Grid item lg={3} md={3} sm={6} xs={12}>
                                <Typography>Service Requested:</Typography>
                                <Typography fontWeight="bold">{item.created_at ? Moment(item.created_at).format('MM-DD-YYYY') : 'N/A'}</Typography>
                            </Grid>

                            {/* Column 3: Status Timeline */}
                            <Grid item lg={3} md={3} sm={6} xs={12}>
                                <Typography>Status:</Typography>
                                <Box pl={2}>
                                <Stepper orientation="vertical" connector={<CustomConnector />}>
                                    {(isExpanded ? steps.filter((_, i) => i === statusIndex) : steps).map((step, index) => (
                                    <Step key={index} active={step.active}>
                                        <StepLabel
                                        icon={<CustomStepIcon active={step.active} />}
                                        sx={{
                                            padding: 0,
                                            '& .MuiStepLabel-label': {
                                            color: step.active ? 'green' : 'black',
                                            fontSize: '0.875rem',
                                            padding: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            },
                                        }}
                                        >
                                        {step.label === "Pending For Review"  ? (
                                            <>
                                                {step.label}
                                                {(item.status !== "Service Request Accepted" && item.status !== "Expert Assigned" && item.status !== "In Process")  && (
                                                <VisibilityOutlinedIcon fontSize="small" sx={{cursor:"pointer",color:"black"}}
                                                onClick={() => handleOpenViewFile(item.media_service_id,item.status === "Completed" ? "approved_documents" : "pending_documents",
                                                item.id,item.media_type,item.status
                                                    )}
                                                />
                                                )} 
                                            </>
                                            ) : (
                                            step.label
                                            )}
                                        </StepLabel>
                                    </Step>
                                    ))}
                                </Stepper>
                                </Box>
                            </Grid>

                            {/* Column 4: Actions */}
                            <Grid item lg={3} md={3} sm={6} xs={12}>
                                <Grid container item lg={12} md={12} sm={6} xs={12}>
                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        {!isExpanded && (
                                            <>
                                                <Typography>Action:</Typography>
                                                <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                                                {(item.status !== "Approved" && item.status !== "Completed")  && (
                                                <Button variant="contained" sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px',textTransform: "capitalize" }}  onClick={() => handleClickOpen(item.id, item.media_service_id,item.media_type)}>
                                                Add Note
                                                </Button>
                                                )}
                                                {/* {item.status !== "Service Request Accepted" && (
                                                    <Button variant="contained" sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px',textTransform: "capitalize" }}  onClick={() => handleOpenViewFile(item.media_service_id,item.status === "Completed" ? "approved_documents" : "pending_documents")}>
                                                    View File
                                                    </Button>
                                                )}   */}
                                                {/* {item.status == "Pending For Review" && (
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        sx={{ backgroundColor: '#6CC641', fontWeight: 'bold', 
                                                            borderRadius: '10px', textTransform: "capitalize",minWidth:150 }}
                                                        onClick={() => setOpenApprovePopup(item.requestId,item.media_type)}
                                                    >
                                                        Approve
                                                    </Button>
                                                )} */}
                                                <Button
                                                    variant="contained"
                                                    sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px', textTransform: "capitalize" }}
                                                    onClick={() => viewActivity(item.requestId,item.media_type)}
                                                >
                                                    Activity Log
                                                </Button>
                                                {
                                                        assetLink != null ?
                                                        <Button variant="contained" sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px', textTransform: "capitalize" }}
                                                            onClick={() => handleOpenAssets(item.requestId,item.media_service_id,item.media_type)}>
                                                            View Assets</Button>
                                                    : ''
                                                    }   
                                                </Box>
                                            </>
                                        )}
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <Button
                                            variant="text"
                                           onClick={() => {
                                                setExpandedIndexes((prev) =>
                                                    prev.includes(uniqueKey)
                                                    ? prev.filter((key) => key !== uniqueKey)
                                                    : [...prev, uniqueKey]
                                                );
                                                }}         
                                        
                                            sx={{
                                                color: '#2E67BC',
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                mt: 1
                                            }}
                                            endIcon={isExpanded ?<KeyboardArrowDownIcon /> :  <KeyboardArrowUpIcon />}
                                            >
                                            {isExpanded ? 'See More' : 'See Less'}
                                        </Button>
                                    </Grid>
                                </Grid>
                                
                            
                            </Grid>
                        
                        </Grid>
                    </CardContent>
                </Card>
            );
        })}

        </Grid>
        :
            <Box>
                <ActivityLog activityLog={activityLog} activityType={activityType} setActiveSection={setActiveSection} cid={companyId} assetLink={assetLink}/>
            </Box>
        }
            <Formik
                enableReinitialize
                initialValues={{ title: "",description:"",ref_img:"",media_config_id:mediaConfigId,media_service_id:mediaServiceId,company_master_id:companyId }}
                validationSchema={validationSchema} 
                onSubmit={async (values, { resetForm }) => {
                    handleFreezStart();
                    const apiUrl = '/addNote';
                    const formDataToSend = new FormData();
                    formDataToSend.append('mediatype', mediatype);
                    formDataToSend.append('title', values.title);
                    formDataToSend.append('description', values.description);
                    formDataToSend.append('ref_img', values.ref_img);
                    formDataToSend.append('media_config_id', values.media_config_id);
                    formDataToSend.append('media_service_id', values.media_service_id);
                    formDataToSend.append('company_master_id', values.company_master_id);
                    try {
                        const res = await dispatch(postFormData({ apiUrl, formData: formDataToSend })).unwrap();
                        if (res && res.success === true) {
                            swal({
                                title: "Success",
                                text: res.message,
                                icon: "success",
                                button: "Ok",
                            }).then(() => {
                                handleFreezStop();
                                resetForm();
                                handleClose();
                            });
                        } else {
                            swal({
                                title: "Failure",
                                text: res.message || "Something went wrong",
                                icon: "error",
                                button: "Ok",
                            });
                            handleFreezStop();
                            resetForm();
                            handleClose();
                        }
                    } catch (err) {
                        handleFreezStop();
                        console.error("API Error:", err);
                        if (err?.errors) {
                            alert(Object.values(err.errors).flat().join('\n'));
                        } else {
                            alert("Something went wrong!");
                        }
                    }
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue,resetForm }) => (
                    
                <>
                    <Dialog
                        open={open}
                        sx={{borderRadius:"10px"}}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={fullWidth}
                        maxWidth={maxWidth}
                    >
                        <form onSubmit={handleSubmit} style={{width:"100%"}}>
                        <Card>
                        <CardContent> 
                            <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"}> 
                                <Grid item lg={9} md={9} sm={9} xs={9}>
                                    <Typography variant='h6'><b>Send A Note To Us</b></Typography>
                                </Grid>
                                <Grid item lg={3} md={3} sm={3} xs={3} textAlign={"right"}>
                                    <Button onClick={handleClose}><img src={require('../../../../assets/images/close.png')} /></Button>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}> 
                                <TextField
                                margin='dense'
                                fullWidth
                                label="Title*"
                                name="title"
                                value={values.title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.title && Boolean(errors.title)}
                                helperText={touched.title && errors.title}
                                />
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}> 
                                <FormControl fullWidth margin="dense">
                                    <TextareaAutosize
                                        margin="dense"
                                        aria-label="minimum height"
                                        minRows={5}
                                        placeholder="Description*"
                                        fullWidth
                                        sx={{ borderColor: touched.description && errors.description ? 'rgb(211 47 47)' : '#D3D3D3',}}
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        />
                                        {touched.description && errors.description && (
                                        <Typography variant="caption" color="error">{errors.description}</Typography>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}> 
                                <FormControl variant="outlined" fullWidth margin="dense" >
                                <InputLabel htmlFor="uploadedLogoStep1">Upload Video/Image For Reference (Optional)</InputLabel>
                                <OutlinedInput
                                    id="uploadedLogo"
                                    type="text" // Show the file name instead of the file picker
                                
                                    value={values.ref_img?.name || ""}
                                    endAdornment={
                                    <InputAdornment position="end">
                                        <Tooltip
                                        title={"Upload Video"}
                                        >
                                        <IconButton edge="end" onClick={() => fileInputRef.current.click()}>
                                        <img src={require("../../../../assets/icons/uploadIcon.png")} style={{ height: "15px" }} alt="Upload" />
                                        </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                    }
                                    label="Upload Video/Image For Reference (Optional)"
                                />
                                <input
                                    id="hiddenFileInputStep1"
                                    ref={fileInputRef}
                                    type="file"
                                    name="uploaded"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        e.target.value = null;

                                        if (file) {
                                        const allowedTypes = [
                                            "image/jpeg", "image/png", "image/jpg", "image/gif",
                                            "video/mp4", "video/webm", "video/ogg"
                                        ];

                                        if (!allowedTypes.includes(file.type)) {
                                            alert("Only JPEG, PNG, GIF images or MP4, WebM, OGG videos are allowed.");
                                            return;
                                        }

                                        if (file.type.startsWith("image/")) {
                                            const img = new Image();
                                            img.onload = () => {
                                                setFieldValue("ref_img", file);
                                            };
                                            img.src = URL.createObjectURL(file);
                                        } else if (file.type.startsWith("video/")) {
                                            const maxSizeInBytes = 150 * 1024 * 1024; // 150 MB

                                            if (file.size > maxSizeInBytes) {
                                            alert("Video must not be larger than 150 MB.");
                                            return;
                                            }

                                            setFieldValue("ref_img", file);
                                        }
                                        }
                                    }}
                                    style={{ display: "none" }}
                                    accept="image/*,video/*"
                                    />
                                   
                                </FormControl>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                                <Typography variant="caption"><i><b>*Only One Revision Allowed Please Ensure You Provide All Inputs.</b></i></Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                <Button variant='contained' fullWidth sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px' }} type='submit'>Submit</Button>
                            </Grid>
                        </CardContent>
                    </Card>
                    </form>
                    </Dialog>
                </>
                )}
            </Formik>
            <Dialog
                open={open1}
                sx={{borderRadius:"10px"}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
               <Card>
                <CardOverflow
                    sx={{
                        bgcolor:'#2E67BC',
                        borderColor:'#2E67BC',
                        padding: '1%',
                    }}
                >
                    <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"right"}>
                            <Button onClick={handleCloseViewFile}><img src={require('../../../../assets/images/closeWhite.png')} /></Button>
                        </Grid>
                </CardOverflow>
                <CardContent> 
                    <Grid container spacing={2} mt={2}>
                    {files.length === 0 ? (
                        <Typography>No files found.</Typography>
                    ) : (
                        files.map((file) => {
                        const name = file.name.toLowerCase();
                        const isVideo = name.endsWith(".mp4");
                        const isImage = name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png") || name.endsWith(".gif");

                        return (
                            <Grid
                                item
                                key={file.id || file.path_lower}
                                xs={12}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                {approveMediaStatus === "Pending For Review" ? (
                                    isVideo ? (
                                        <video
                                            width={isMobile ? "100%" : "250px"}
                                            height="100%"
                                            controls
                                            controlsList="nodownload"
                                            src={file.temporary_link}
                                             style={{ borderRadius: 0 }}
                                            onContextMenu={(e) => e.preventDefault()}
                                        />
                                    ) : isImage ? (
                                        <WatermarkedImage
                                            imageUrl={file.temporary_link}
                                            altText={file.name}
                                            isMobile={isMobile}
                                            watermarkText="MyFreeScoreNow"
                                            
                                        />
                                    ) : null
                                ) : (
                                    isVideo ? (
                                        <video
                                            width={isMobile ? "100%" : "250px"}
                                            height="100%"
                                            controls
                                            src={file.temporary_link}
                                            style={{ borderRadius: 0, }}
                                        />
                                    ) : isImage ? (
                                        <img
                                            src={file.temporary_link}
                                            alt={file.name}
                                            style={{ width: "250px", height: "auto", borderRadius: 0, objectFit: "cover" }}
                                        />
                                    ) : null
                                )}

                                {(approveMediaStatus === "Approved" || approveMediaStatus === "Completed") && (
                                    <a
                                        href={file.temporary_link}
                                        download={file.name}
                                        style={{ marginTop: "10px", textDecoration: "none" }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Button
                                            variant='contained'
                                            color='success'
                                            sx={{
                                                backgroundColor: '#6CC641',
                                                fontWeight: 'bold',
                                                borderRadius: '10px',
                                                textTransform: "capitalize",
                                                minWidth: 150
                                            }}
                                        >
                                            Download
                                        </Button>
                                    </a>
                                )}
                            </Grid>
                        );
                        })
                    )}
                    
                    </Grid>
                </CardContent>
                <CardActions>
                    <Grid container item xs={12} sm={12} md={12} lg={12} display={"flex"} justifyContent={isMobile?"center":"end"} gap={isMobile?1:3}>
                        
                        <Grid item>
                            { approveMediaStatus === "Pending For Review" ?
                            <Button variant='outlined' color='success'
                                sx={{  fontWeight: 'bold', 
                                    borderRadius: '10px', textTransform: "capitalize",minWidth:150 }}
                                    onClick={() => setOpenApprovePopup(requestId,approveMediaType)}
                            >Approve</Button>
                            :""
                            }
                        </Grid>
                        <Grid item>
                               {(approveMediaStatus !== "Approved" && approveMediaStatus !== "Completed")  && (
                            <Button variant="contained" sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px',textTransform: "capitalize" }}  onClick={() =>handleClickOpen(requestId, mediaServiceId,approveMediaType)} >
                                Add Note
                            </Button>
                                )}
                        </Grid>
                    </Grid>
                </CardActions>
               </Card>
            </Dialog>

            <Dialog
                open={openApprove}
                sx={{borderRadius:"10px"}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                <DialogTitle className="dialog-title" >
                    <Typography variant="h6" fontWeight="bold"> Confirmation </Typography>
                    <IconButton onClick={(e)=>{setOpenApprove(false);}}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Typography>Are  You Sure You Want To Approve This Media Service</Typography>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }} spacing={2} mt={1}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained" 
                                onClick={(e)=>{
                                    setOpenApprove(false);
                                }}
                                className="cancel-button">
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained" onClick={() => setApprove(requestId,mediatype)} className="save-button">
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
               
            </Dialog>

            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
                
        </>
    )
}
export default AvailedServicesIndex;